import React from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import { GlobalHistory } from './Components/Common/GlobalHistory';

import { AllRouter } from './Router/RouterData';
import { ErrorPage } from "./Pages/ErrorPage";

import './App.css';

function App(props) {
  return (
    <div className="App">
      <Router basename={'/' + process.env.REACT_APP_SUB_FOLDER}>
        <GlobalHistory />
        <Switch>
          {
            AllRouter.map((layout, layoutKey) => (
              <layout.Layout path={layout.Path} key={layoutKey}>
                <Switch>
                  {
                    layout.Routers.map((route, routeKey) => (
                      <Route
                        key={routeKey}
                        exact={route.exact}
                        path={route.path}
                        render={props => (
                          <route.component {...props} />
                        )}
                      />
                    ))
                  }
                  <Route component={ErrorPage} />
                </Switch>
              </layout.Layout>
            ))
          }
        </Switch>
      </Router>
    </div>
  );
}

export default App;
